import Hero from "@/components/site/Hero";
import MascotIntro from "@/components/site/MascotIntro";
import ValueProps from "@/components/site/ValueProps";
import HowItWorks from "@/components/site/HowItWorks";
import ForOwners from "@/components/site/ForOwners";
import FinalCta from "@/components/site/FinalCta";

export default function Home() {
  return (
    <>
      <Hero />
      <MascotIntro />
      <ValueProps />
      <HowItWorks />
      <ForOwners />
      <FinalCta />
    </>
  );
}
